import { CheckoutProps } from './types';
import { StyledCheckout } from './style';

export const Checkout: React.FC<CheckoutProps> = ({ children }) => {
  return <StyledCheckout className="checkout-page">{children}</StyledCheckout>;
};
